var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v(_vm._s(_vm.list))]),_c('div',[_vm._v("L'id du dernier est : "+_vm._s(_vm.lastId()))])])}
var staticRenderFns = []

export { render, staticRenderFns }